import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["layoutType"],
  _excluded2 = ["layoutType"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { FieldDate, FieldSelect } from '@snack-uikit/fields';
import { MobileFieldDate } from '../MobileFieldDate';
import { MobileFieldSelect } from '../MobileFieldSelect';
import { jsx as _jsx } from "react/jsx-runtime";
export function AdaptiveFieldSelect(_ref) {
  var layoutType = _ref.layoutType,
    props = _objectWithoutProperties(_ref, _excluded);
  var isMobile = layoutType === 'mobile';
  return isMobile ? /*#__PURE__*/_jsx(MobileFieldSelect, _objectSpread({}, props)) : /*#__PURE__*/_jsx(FieldSelect, _objectSpread({}, props));
}
export function AdaptiveFieldDate(_ref2) {
  var layoutType = _ref2.layoutType,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var isMobile = layoutType === 'mobile';
  return isMobile ? /*#__PURE__*/_jsx(MobileFieldDate, _objectSpread({}, props)) : /*#__PURE__*/_jsx(FieldDate, _objectSpread({}, props));
}